import { useEffect, useRef, useState } from 'react';
import { flowResult } from 'mobx';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useStore } from '../../../core/utils/hook';
import { MSG, SYSTEM_PATH } from '../../../core/configs/constants';

export function useMailSubscriptionLinkVerify() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const ranRef = useRef(false);
    const [phase, setPhase] = useState(() => (searchParams.get('token') ? 'checking' : 'none'));
    const [linkTokenError, setLinkTokenError] = useState(null);
    const { userStore: { verifyMailSubscriptionToken } } = useStore();

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token || ranRef.current) return;
        ranRef.current = true;

        const strip = () =>
            navigate({ pathname: SYSTEM_PATH.MAIL_SUBSCRIPTION, search: '' }, { replace: true });

        (async () => {
            const res = await flowResult(verifyMailSubscriptionToken(token));
            if (res?.ok) {
                setLinkTokenError(null);
                setPhase('ready');
            } else {
                setLinkTokenError(res?.message || MSG['api.response.server_error']);
                setPhase('bad');
            }
            strip();
        })();
    }, [searchParams, navigate, verifyMailSubscriptionToken]);

    return { linkTokenError, showMailSettingsForm: phase === 'ready' };
}
